import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import router from "./router";
import Toastify from 'toastify-js';
// import SecureLS from "secure-ls";
// var ls = new SecureLS({ isCompression: false });
const store = createStore({
  state: {
    user: null,
    tabs: {
      components: [],
      selected: ""
    },
    tabsClicked: false,
    waitOnlineReservations: null,
    muteAlarm: false,
    notifications: [],
    routes: {
      "/users": {
        name: "users",
        url: "/users",
        title: "Users",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/myHotels": {
        name: "myHotels",
        url: "/myHotels",
        title: "My Hotels",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/accounts": {
        name: "accounts",
        url: "/accounts",
        title: "Accounts",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/notifications": {
        name: "notifications",
        url: "/notifications",
        title: "Notifications",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/currencies": {
        name: "currencies",
        url: "/currencies",
        title: "Currencies",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/languages": {
        name: "languages",
        url: "/languages",
        title: "Languages",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/countries": {
        name: "countries",
        url: "/countries",
        title: "Countries",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/operators": {
        name: "operators",
        url: "/operators",
        title: "Operators",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/reservations": {
        name: "reservations",
        url: "/reservations",
        title: "Reservations",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/workers": {
        name: "workers",
        url: "/workers",
        title: "Workers",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/branchs": {
        name: "branchs",
        url: "/branchs",
        title: "Branchs",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/customers": {
        name: "customers",
        url: "/customers",
        title: "Customers",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/customerProviders": {
        name: "customerProviders",
        url: "/customerProviders",
        title: "Customer Providers",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/checkUser": {
        name: "checkUser",
        url: "/checkUser",
        title: "Check User",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/softwares": {
        name: "softwares",
        url: "/softwares",
        title: "Softwares",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/destination/towns": {
        name: "destinationTowns",
        url: "/destination/towns",
        title: "DestinationTowns",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/hotels": {
        name: "hotels",
        url: "/hotels",
        title: "Hotels",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/hotel/match": {
        name: "hotelDetail",
        url: "/hotel/match",
        title: "HotelMatch",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/hotelGroups": {
        name: "hotelGroups",
        url: "/hotelGroups",
        title: "Hotel Groups",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/scans": {
        name: "scans",
        url: "/tourscope/scans",
        title: "Scans",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/local/scans": {
        name: "localScans",
        url: "/tourscope/local/scans",
        title: "LocalScans",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/createListScanItems": {
        name: "createListScanItems",
        url: "/tourscope/createListScanItems",
        title: "CreateListScanItems",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/operators": {
        name: "operator",
        url: "/tourscope/operators",
        title: "Operator",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/operator/countries": {
        name: "operatorCountries",
        url: "/tourscope/operator/countries",
        title: "OperatorCountries",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/departure/cities": {
        name: "departureCities",
        url: "/tourscope/departure/cities",
        title: "DepartureCities",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/operator/departure/cities": {
        name: "operatorDepartureCities",
        url: "/tourscope/operator/departure/cities",
        title: "OperatorDepartureCities",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/operator/hotels": {
        name: "operatorHotels",
        url: "/tourscope/operator/hotels",
        title: "OperatorHotels",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/operator/match/report": {
        name: "operatorMatchReport",
        url: "/tourscope/operator/match/report",
        title: "Operator Match Report",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/searchMinPrices": {
        name: "searchMinPrices",
        url: "/tourscope/searchMinPrices",
        title: "Search Min Prices",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/tourscope/scanErrors": {
        name: "scanErrors",
        url: "/tourscope/scanErrors",
        title: "Scan Errors",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/providers": {
        name: "providers",
        url: "/kolayrez/providers",
        title: "Kolayrez Providers",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/match/country": {
        name: "kolayrezCountry",
        url: "/kolayrez/match/country",
        title: "Kolayrez Software Country",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/match/currencies": {
        name: "kolayrezCurrencies",
        url: "/kolayrez/match/currencies",
        title: "Kolayrez Software Currencies",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/match/markets": {
        name: "kolayrezMarkets",
        url: "/kolayrez/match/markets",
        title: "Kolayrez Provider Markets",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/match/citizenships": {
        name: "kolayrezCitizenships",
        url: "/kolayrez/match/citizenships",
        title: "Kolayrez Provider Citizenships",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/match/hotelNames": {
        name: "kolayrezHotelNames",
        url: "/kolayrez/match/hotelNames",
        title: "Kolayrez Hotel Names",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/match/agencyOperators ": {
        name: "kolayrezAgencyOperators",
        url: "/kolayrez/match/agencyOperators",
        title: "Kolayrez Agency Operators",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/scanErrors": {
        name: "kolayrezScanErrors",
        url: "/kolayrez/scanErrors",
        title: "Kolayrez Scan Errors",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/PMSLogs": {
        name: "PMSLogs",
        url: "/kolayrez/PMSLogs",
        title: "Kolayrez PMS Logs",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/tempReservations": {
        name: "tempReservations",
        url: "/kolayrez/tempReservations",
        title: "Kolayrez Temp Reservations",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/customerProvidersLogs": {
        name: "CustomerProvidersLogs",
        url: "/kolayrez/customerProvidersLogs",
        title: "Customer Providers Logs",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/mails": {
        name: "kolayrezMails",
        url: "/kolayrez/mails",
        title: "Kolayrez Mails",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/confirmedDocument": {
        name: "confirmedDocument",
        url: "/kolayrez/confirmedDocument",
        title: "Kolayrez Confirmed Documents",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/report/using": {
        name: "usingReport",
        url: "/report/using",
        title: "Using Report",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/schema": {
        name: "schema",
        url: "/schema",
        title: "Schema",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/arrayDiff": {
        name: "arrayDiff",
        url: "/arrayDiff",
        title: "Array Diff",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/technicals/squids": {
        name: "squids",
        url: "/technicals/squids",
        title: "Squids",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/technicals/dedicatedProxies": {
        name: "dedicatedProxies",
        url: "/technicals/dedicatedProxies",
        title: "Dedicated Proxies",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/technicals/queues": {
        name: "queues",
        url: "/technicals/queues",
        title: "Queues",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/research/room/availibility": {
        name: "roomAvailibility",
        url: "/research/room/availibility",
        title: "Room Availibility",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/research/providerBasedReservations": {
        name: "providerBasedReservations",
        url: "/research/providerBasedReservations",
        title: "Provider Based Reservations",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/research/improve1": {
        name: "improve1",
        url: "/research/improve1",
        title: "Improve1",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/technicals/mailWorkers": {
        name: "mailWorkers",
        url: "/technicals/mailWorkers",
        title: "Mail Workers",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/kolayrez/sednaReservationLogs": {
        name: "sednaReservationLogs",
        url: "/kolayrez/sednaReservationLogs",
        title: "Sedna Reservation Logs",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      },
      "/test": {
        name: "test",
        url: "/test",
        title: "Test",
        uid: Math.floor((1 + Math.random()) * 0x100000000000),
        isOne: true
      }
    },
    requestWatch: {}
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setTabsClicked(state, val) {
      state.tabsClicked = val;
    },
    addTabItem(state, items) {
      if (router.currentRoute._value.name == "Login" || router.currentRoute._value.path == "/" || items == undefined) {
        return false;
      }
      var item = items;
      item.uid = Math.floor((1 + Math.random()) * 0x100000000000);
      var isPush = true;
      if (item.isOne == true || state.tabsClicked) {
        state.tabsClicked = false;
        state.tabs.components.forEach(element => {
          if (element.uid == item.uid) {
            state.tabs.selected = element.uid;
            isPush = false;
          }
        });
      }
      if (isPush) {
        state.tabs.components.push(item);
      }
      state.tabs.selected = item.uid;
      router.push(item.url);
    },
    addDirectTabItem(state, item) {
      var uid = item.uid;
      if (!item.isOne) {
        uid = Math.floor((1 + Math.random()) * 0x100000000000);
      }
      state.tabs.components.push({ ...item, uid: uid });
      state.tabs.selected = uid;
    },
    removeTabItem(state, uid) {
      var changeSelected = uid == state.tabs.selected;
      state.tabs.components = state.tabs.components.filter(x => x.uid != uid);
      if (changeSelected && state.tabs.components.length > 0) {
        state.tabs.selected = state.tabs.components[0].uid;
        router.push(state.tabs.components[0].url)
      } else {
        router.push("/")
      }
    },
    orderTabs(state, order) {
      var components = [];
      state.tabs.components.forEach((element, index) => {
        if (order.drop == 0 && order.drop == index) {
          components.push(state.tabs.components[order.drag]);
        }
        if (index != order.drag) {
          components.push(element);
        }
        if (order.drag < order.drop) {
          if (index == order.drop) {
            components.push(state.tabs.components[order.drag]);
          }
        } else {
          if (index == (order.drop - 1)) {
            components.push(state.tabs.components[order.drag]);
          }
        }
      });
      state.tabs.components = components;
    },
    setWaitOnlineReservations(state, data) {
      var newData = [];
      if (state.waitOnlineReservations != null) {
        var oldIds = [];
        state.waitOnlineReservations.Rows.forEach(element => {
          oldIds.push(element.Id);
        });
        newData = data.Rows.filter(x => { return oldIds.indexOf(x.Id) == -1 })
      }
      state.waitOnlineReservations = data;
      if (state.waitOnlineReservations.Rows.length == 0) {
        document.title = "Kolayrez V2";
      } else {
        document.title = state.waitOnlineReservations.Rows.length + " Bekleyen Rezervasyon";
      }
      if (newData.length > 0) {
        state.notifications.unshift({
          title: "Kolayrez",
          text: newData.length + " yeni rezervasyon geldi.",
          icon: "mdi mdi-weather-sunset-down",
          type: "info",
          link: "#/waitOnlineReservations"
        });
        if (!state.muteAlarm) {
          let audio = new Audio("./sound/" + state.user.Alarm + ".mp3");
          audio.play()
        }
        Toastify({
          text: "<p><b>Yeni Rezervasyon</b>" + newData.length + " adet yeni rezervasyon geldi.</p>",
          duration: 3000,
          // destination: "https://github.com/apvarun/toastify-js",
          newWindow: true,
          close: true,
          escapeMarkup: false,
          gravity: "bottom", // `top` or `bottom`
          position: "right", // `left`, `center` or `right`
          stopOnFocus: true, // Prevents dismissing of toast on hover
          onClick: function () { } // Callback after click
        }).showToast();
      }
    },
    setMuteAlarm(state, value) {
      state.muteAlarm = value;
    },
    setRequestWatch(state, data) {
      // console.log("setRequestWatch", data);
      if (state.requestWatch[data.url] == undefined) {
        state.requestWatch[data.url] = {
          requests: [],
          diffTime: null
        };
      }
      state.requestWatch[data.url].requests.push({
        ...data,
        date: new Date()
      });
      if (state.requestWatch[data.url].requests.length > 1) {
        let diff = state.requestWatch[data.url].requests[state.requestWatch[data.url].requests.length - 1].date.getTime() - state.requestWatch[data.url].requests[state.requestWatch[data.url].requests.length - 2].date.getTime()
        if (state.requestWatch[data.url].diffTime == null || state.requestWatch[data.url].diffTime > diff) {
          state.requestWatch[data.url].diffTime = Math.round(diff / 1000);
        }
      }
    }
    // setRequestWatch(state, data) {
    //   if (state.requestWatch[data.responseURL] == undefined) {
    //     state.requestWatch[data.responseURL] = {
    //       requests: [],
    //       diffTime: null
    //     };
    //   }
    //   state.requestWatch[data.responseURL].requests.push({
    //     date: new Date(),
    //     status: data.status,
    //     responseText: data.responseText,
    //     responseURL: data.responseURL
    //   });
    //   if (state.requestWatch[data.responseURL].requests.length > 1) {
    //     let diff = state.requestWatch[data.responseURL].requests[state.requestWatch[data.responseURL].requests.length - 1].date.getTime() - state.requestWatch[data.responseURL].requests[state.requestWatch[data.responseURL].requests.length - 2].date.getTime()
    //     if (state.requestWatch[data.responseURL].diffTime == null || state.requestWatch[data.responseURL].diffTime > diff) {
    //       state.requestWatch[data.responseURL].diffTime = diff;
    //     }
    //   }
    //   console.log("setRequestWatch", state.requestWatch[data.responseURL].requests[state.requestWatch[data.responseURL].requests.length - 1].date.getTime());
    // }
  },
  actions: {
  },
  getters: {
    _isAuthenticated: state => state.user !== null
  },
  plugins: [
    createPersistedState(),
    function (store) {
      console.log("createPersistedState", store);
      store._state.data.tabs.components = [];
      store._state.data.tabs.selected = "";
      store._state.data.leftSidebarShow = true;
      store._state.data.waitOnlineReservations = null;
    }
  ]
});

export default store;